import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid-3 gap-sm" }
const _hoisted_2 = {
  key: 0,
  class: "span-2"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { User } from '@/modules/user/User';
import PageLayout from '@/core/components/PageLayout.vue';
import DashboardTicketStatistics from '@/modules/dashboard/components/DashboardTicketStatistics.vue';
import DashboardTicketsList from '@/modules/dashboard/components/DashboardTicketsList.vue';
import DashboardPartnerStatistics from '@/modules/dashboard/components/DashboardPartnerStatistics.vue';
import DashboardMasterStatistics from '@/modules/dashboard/components/DashboardMasterStatistics.vue';
import DashboardNewsList from '@/modules/dashboard/components/DashboardNewsList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardPage',
  setup(__props) {

const { $gettext } = useGettext();
const store = useStore<AppStore>();
const authenticatedUser = computed<User | null>(() => store.state.authenticatedUser);
const isCustomerOrLawFirm = computed<boolean>(() => (
	authenticatedUser.value?.type === 'CUSTOMER'
	|| authenticatedUser.value?.type === 'LAW_FIRM'
));
const isPartner = computed<boolean>(() => authenticatedUser.value?.type === 'PARTNER');
const isMaster = computed<boolean>(() => authenticatedUser.value?.type === 'MASTER');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Översikt')
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (isCustomerOrLawFirm.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(DashboardTicketStatistics),
              _createVNode(DashboardTicketsList)
            ]))
          : _createCommentVNode("", true),
        (isPartner.value)
          ? (_openBlock(), _createBlock(DashboardPartnerStatistics, {
              key: 1,
              class: "span-2"
            }))
          : _createCommentVNode("", true),
        (isMaster.value)
          ? (_openBlock(), _createBlock(DashboardMasterStatistics, {
              key: 2,
              class: "span-2"
            }))
          : _createCommentVNode("", true),
        _createVNode(DashboardNewsList)
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})